import { render, staticRenderFns } from "./WeDataField.vue?vue&type=template&id=a825a8fc&"
import script from "./WeDataField.vue?vue&type=script&lang=js&"
export * from "./WeDataField.vue?vue&type=script&lang=js&"
import style0 from "./WeDataField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports